import React from "react";

import { api } from "src/common/utils/api";
import { confirmSignOut } from "src/features/auth/session";
import { useCreateGenericError } from "src/features/notifications";

interface UseSignOutOptions {
	notifyOnFailure?: boolean;
}

export function useSignOut({
	notifyOnFailure = true
}: UseSignOutOptions = {}): () => Promise<boolean> {
	const createGenericError = useCreateGenericError();
	return React.useCallback(async () => {
		try {
			await api.post("/authflow/logout");
			confirmSignOut();
			return true;
		} catch {
			if (notifyOnFailure) {
				createGenericError();
			}
			return false;
		}
	}, [createGenericError, notifyOnFailure]);
}
